"use client";

import { TempUnit, Language } from "@/types/weather";
import { t } from "@/lib/i18n";

interface HeaderProps {
  unit: TempUnit;
  lang: Language;
  onUnitToggle: () => void;
  onLangToggle: () => void;
  onRefresh: () => void;
  isRefreshing: boolean;
}

export default function Header({
  unit,
  lang,
  onUnitToggle,
  onLangToggle,
  onRefresh,
  isRefreshing,
}: HeaderProps) {
  return (
    <header className="border-b border-white/5 backdrop-blur-sm sticky top-0 z-10">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="text-2xl">🌍</span>
          <span className="text-white font-semibold text-lg">
            {t(lang, "appName")}
          </span>
          {process.env.NEXT_PUBLIC_APP_ENV === "staging" && (
            <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-yellow-500/20 text-yellow-300 border border-yellow-500/30">
              開発環境
            </span>
          )}
          {process.env.NEXT_PUBLIC_APP_ENV === "production" && (
            <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-green-500/20 text-green-300 border border-green-500/30">
              本番環境
            </span>
          )}
        </div>
        <div className="flex items-center gap-2">
          {/* Language Toggle */}
          <button
            onClick={onLangToggle}
            className="px-3 py-1.5 rounded-lg text-sm font-medium transition-all duration-200 bg-white/10 hover:bg-white/20 text-white border border-white/10"
            title="Switch language / 言語切替"
          >
            {lang === "en" ? "🇯🇵 日本語" : "🇬🇧 English"}
          </button>

          {/* °C / °F Toggle */}
          <button
            onClick={onUnitToggle}
            className="px-3 py-1.5 rounded-lg text-sm font-medium transition-all duration-200 bg-white/10 hover:bg-white/20 text-white border border-white/10"
            title="Toggle temperature unit"
          >
            {unit === "celsius" ? "°C → °F" : "°F → °C"}
          </button>

          {/* Refresh Button */}
          <button
            onClick={onRefresh}
            disabled={isRefreshing}
            className="px-3 py-1.5 rounded-lg text-sm font-medium transition-all duration-200 bg-white/10 hover:bg-white/20 text-white border border-white/10 disabled:opacity-50"
            title="Refresh weather data"
          >
            <span className={isRefreshing ? "animate-spin inline-block" : ""}>
              🔄
            </span>
          </button>

          <span className="text-slate-500 text-xs hidden sm:block">
            {t(lang, "poweredBy")}
          </span>
        </div>
      </div>
    </header>
  );
}
